import yup from 'helpers/validations';
import { FORM_FIELDS } from '../../../../../../constants';

export const schema = () =>
    yup.object({
        [FORM_FIELDS.MONTHLY_SALARY]: yup
            .number()
            .integer()
            .min(20_000, 'Минимальный доход - 20 000р')
            .max(10_000_000, 'Максимальный доход - 10\u00A0000\u00A0000р'),
    });
